import { BaseItem } from '../common';

export enum NoteFieldFormat {
  BoldCompact = 'BOLD_COMPACT',
  BoldStandard = 'BOLD_STANDARD',
  PlainCompact = 'PLAIN_COMPACT',
  PlainStandard = 'PLAIN_STANDARD',
}

export enum ExportFingerprintNote {
  OnPrevisitSubmit = 'ON_PREVISIT_SUBMIT',
  OnCheckIn = 'ON_CHECK_IN',
  OnReadyForProvider = 'ON_READY_FOR_PROVIDER',
  Disabled = 'DISABLED',
}

export enum AnalystSpecialty {
  Transcribing = 'TRANSCRIBING',
  Structuring = 'STRUCTURING',
  None = 'NONE',
}

export enum NameFormat {
  FirstLast = 'FIRST_LAST',
  LastFirst = 'LAST_FIRST',
}

export enum SignAndCloseKind {
  Chart = 'CHART',
  Note = 'NOTE',
  None = 'NONE',
}

export enum ExportAllNoteFieldsSection {
  AP = 'A/P',
  Header = 'Header',
}

export interface FullPreferenceDetail {
  alwaysExtractCarryCurrent: boolean;
  alwaysNeedsReview: boolean;
  analystSpecialty: AnalystSpecialty;
  appendInterpretationsToExam: boolean;
  autoApplyPrevisitFormTemplates: boolean;
  carryCurrentPrevisit: boolean;
  clinOpsNoteFormat1: boolean;
  compactTitles: boolean;
  disableNoteExports: boolean;
  disableOrganSystemFields: boolean;
  displayEncountersNDaysInFuture: number;
  enableTrainingSegmentsWorkflow: boolean;
  enablePunctuationPrediction: boolean;
  enablePronounUpdate: boolean;
  enableProviderNameUpdate: boolean;
  enableRealTimeDictation: boolean;
  enableVisitTabOnMobile: boolean;
  exportAllNoteFieldsToAP: ExportAllNoteFieldsSection | boolean;
  exportAsDynamicNote: boolean;
  exportFingerprintNote: ExportFingerprintNote;
  exportPrevisitPatientUploads: boolean;
  getNextEncounterPriority: number;
  organSystemsFormat: NoteFieldFormat;
  patientNameFormat: NameFormat;
  realTimeProviderOverride: string;
  signAndCloseKind: SignAndCloseKind;
  smsTwoFactor: boolean;
}

export type PreferenceDetail = Partial<FullPreferenceDetail>;

export type PreferenceOptions = {
  [K in keyof FullPreferenceDetail]: {
    description: string;
    options: FullPreferenceDetail[K][];
    default: FullPreferenceDetail[K];
  };
};

export interface Preference extends BaseItem {
  userId: string;
  // extend with |
  preference: PreferenceDetail;
}
